module.exports = __webpack_public_path__ + "static/img/3.54003cf.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/products/4/1/4/eng/3.png
// module id = plu9
// module chunks = 0